import { PropsWithChildren, useEffect } from "react";
import { useUser } from "@frigade/react";
import useUserStore from "../stores/useUserStore";
import { isObjectEmpty } from "../utils";

export default function ActionsProvider({ children }: PropsWithChildren<{}>) {
  const user = useUserStore((state) => state.user);

  const { setUserIdWithProperties } = useUser();

  useEffect(() => {
    if (!isObjectEmpty(user)) {
      setUserIdWithProperties(user.id, {
        ...(user.isNewUser ? { timeJoined: Date.now() } : {}),
        ...(user.email ? { email: user.email } : {}),
      });
    }
  }, [user]);

  return children;
}
